import { gql } from '@apollo/client';

export const templateItem = gql`
  fragment templateItem on DocumentTemplate {
    documentTemplateId
    templateName
    templateCode
    bulkPrintingYN
  }
`;
